(function(){
  'use strict';
  if(typeof window === 'undefined') return;

  /* ═══════════════════════════════════════════════════════
     JFC Mobile Enhancements
     1. Image counter overlay ("1 / 4")
     2. Fullscreen image viewer with swipe + double-tap zoom
     3. Back-to-top button
     4. Swipe hint on gallery
     ═══════════════════════════════════════════════════════ */

  /* ── CSS ── */
  var css = document.createElement('style');
  css.textContent = [
    /* Image counter */
    '.jfc-img-counter{position:absolute;top:14px;right:14px;background:rgba(11,11,15,.72);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);border:1px solid rgba(242,239,232,.14);color:#F2EFE8;font-size:11.5px;font-weight:600;padding:4px 11px;border-radius:20px;z-index:10;pointer-events:none;letter-spacing:.5px;opacity:0;transition:opacity .3s;}',
    '.jfc-img-counter.vis{opacity:1;}',

    /* Fullscreen viewer */
    '#jfc-lightbox{position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,.97);display:none;flex-direction:column;touch-action:none;}',
    '#jfc-lightbox.open{display:flex;}',
    '.jfc-lb-header{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;flex-shrink:0;}',
    '.jfc-lb-counter{font-size:14px;font-weight:600;color:rgba(255,255,255,.7);}',
    '.jfc-lb-close{background:rgba(255,255,255,.1);border:1.5px solid rgba(255,255,255,.2);color:#fff;cursor:pointer;width:44px;height:44px;padding:0;border-radius:50%;display:flex;align-items:center;justify-content:center;transition:background .2s,border-color .2s;-webkit-tap-highlight-color:transparent;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);}',
    '.jfc-lb-close:hover,.jfc-lb-close:active{background:rgba(168,85,247,.28);border-color:rgba(168,85,247,.55);}',
    '.jfc-lb-track{flex:1;display:flex;overflow:hidden;position:relative;}',
    '.jfc-lb-slide{min-width:100%;display:flex;align-items:center;justify-content:center;padding:16px;}',
    '.jfc-lb-slide img{max-width:100%;max-height:100%;object-fit:contain;border-radius:4px;transition:transform .2s ease;transform-origin:center center;user-select:none;-webkit-user-select:none;pointer-events:none;}',
    /* Prev / next arrows — work on desktop (no swipe) and mobile */
    '.jfc-lb-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:6;width:50px;height:50px;border-radius:50%;background:rgba(255,255,255,.1);border:1.5px solid rgba(255,255,255,.2);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);transition:background .2s,border-color .2s,opacity .2s;-webkit-tap-highlight-color:transparent;}',
    '.jfc-lb-arrow:hover{background:rgba(168,85,247,.28);border-color:rgba(168,85,247,.55);}',
    '.jfc-lb-prev{left:18px;} .jfc-lb-next{right:18px;}',
    '.jfc-lb-arrow[disabled]{opacity:.18;pointer-events:none;}',
    '@media(max-width:749px){.jfc-lb-arrow{width:42px;height:42px;}.jfc-lb-prev{left:8px;}.jfc-lb-next{right:8px;}}',
    '.jfc-lb-dots{display:flex;justify-content:center;gap:7px;padding:18px;flex-shrink:0;}',
    '.jfc-lb-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.3);cursor:pointer;transition:all .2s;}',
    '.jfc-lb-dot.act{background:#a855f7;width:22px;border-radius:4px;}',
    '.jfc-lb-hint{position:absolute;bottom:60px;left:50%;transform:translateX(-50%);font-size:11px;color:rgba(255,255,255,.3);pointer-events:none;transition:opacity .5s;}',

    /* Back to top */
    '#jfc-btt{position:fixed;bottom:20px;left:16px;z-index:998;width:40px;height:40px;border-radius:50%;background:rgba(30,8,53,.9);border:1px solid rgba(139,92,246,.25);display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;pointer-events:none;transition:opacity .3s,transform .3s,bottom .35s;color:#a855f7;-webkit-tap-highlight-color:transparent;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);}',
    '#jfc-btt.vis{opacity:1;pointer-events:auto;}',
    '#jfc-btt:active{transform:scale(.9);}',
    '#jfc-btt.shifted{bottom:140px;}',
    '@media(min-width:750px){#jfc-btt{bottom:24px;left:24px;}#jfc-btt.shifted{bottom:80px;}}',

    /* Gallery swipe hint */
    '.jfc-swipe-hint{position:absolute;top:50%;right:12px;transform:translateY(-50%);display:flex;align-items:center;gap:4px;background:rgba(0,0,0,.5);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);color:rgba(255,255,255,.7);font-size:10px;font-weight:600;padding:6px 10px;border-radius:20px;z-index:5;animation:jfc-swipe-nudge 2s ease-in-out 1s 3;pointer-events:none;opacity:0;transition:opacity .5s;}',
    '.jfc-swipe-hint.vis{opacity:1;}',
    '@keyframes jfc-swipe-nudge{0%,100%{transform:translateY(-50%) translateX(0);}50%{transform:translateY(-50%) translateX(-6px);}}'
  ].join('\n');
  document.head.appendChild(css);


  /* ════════════════════════════════════════════════
     1. IMAGE COUNTER
     ════════════════════════════════════════════════ */
  function initImageCounter(){
    var gallery = document.querySelector('.product__media-wrapper, .product--media');
    var slider = document.querySelector('#GalleryViewer-' + (document.querySelector('[data-section]')?.dataset.section || ''));
    if(!gallery || !slider) return;

    var counter = document.createElement('div');
    counter.className = 'jfc-img-counter';
    gallery.style.position = 'relative';
    gallery.appendChild(counter);

    var mediaItems = slider.querySelectorAll('.product__media-item, .slider__slide');
    var total = mediaItems.length;
    if(total < 2) return;

    function update(){
      var current = 1;
      mediaItems.forEach(function(item, i){
        var rect = item.getBoundingClientRect();
        var parent = slider.getBoundingClientRect();
        if(Math.abs(rect.left - parent.left) < 20) current = i + 1;
      });
      counter.textContent = current + ' / ' + total;
    }

    /* Also watch for Dawn's slider events */
    var scrollEl = slider.querySelector('.slider, .grid--peek');
    if(scrollEl){
      scrollEl.addEventListener('scroll', update, {passive:true});
    }

    /* MutationObserver for class changes (Dawn uses is-active) */
    var mo = new MutationObserver(function(){
      var active = slider.querySelector('.is-active');
      if(active){
        var idx = Array.from(mediaItems).indexOf(active) + 1;
        if(idx > 0) counter.textContent = idx + ' / ' + total;
      }
    });
    mo.observe(slider, {attributes:true, subtree:true, attributeFilter:['class']});

    update();
    setTimeout(function(){ counter.classList.add('vis'); }, 500);
  }


  /* ════════════════════════════════════════════════
     2. FULLSCREEN IMAGE VIEWER
     ════════════════════════════════════════════════ */
  var lbImages = [];
  var lbIndex = 0;
  var lbZoom = 1;
  var lbPanX = 0, lbPanY = 0;

  function buildLightbox(){
    var lb = document.createElement('div');
    lb.id = 'jfc-lightbox';
    lb.innerHTML =
      '<div class="jfc-lb-header">' +
        '<span class="jfc-lb-counter" id="jfc-lb-counter">1 / 4</span>' +
        '<button class="jfc-lb-close" id="jfc-lb-close" aria-label="Close">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>' +
      '<button class="jfc-lb-arrow jfc-lb-prev" id="jfc-lb-prev" aria-label="Previous image"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
      '<div class="jfc-lb-track" id="jfc-lb-track"></div>' +
      '<button class="jfc-lb-arrow jfc-lb-next" id="jfc-lb-next" aria-label="Next image"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>' +
      '<div class="jfc-lb-dots" id="jfc-lb-dots"></div>';
    document.body.appendChild(lb);

    /* Close */
    document.getElementById('jfc-lb-close').addEventListener('click', closeLightbox);
    lb.addEventListener('click', function(e){ if(e.target === lb) closeLightbox(); });

    /* Prev / next arrows — the desktop/non-swipe way to change image */
    document.getElementById('jfc-lb-prev').addEventListener('click', function(e){ e.stopPropagation(); lbIndex = Math.max(lbIndex - 1, 0); snapToSlide(); });
    document.getElementById('jfc-lb-next').addEventListener('click', function(e){ e.stopPropagation(); lbIndex = Math.min(lbIndex + 1, lbImages.length - 1); snapToSlide(); });

    /* Keyboard — Escape closes, arrow keys navigate */
    document.addEventListener('keydown', function(e){
      var box = document.getElementById('jfc-lightbox');
      if(!box || !box.classList.contains('open')) return;
      if(e.key === 'Escape'){ closeLightbox(); }
      else if(e.key === 'ArrowLeft'){ lbIndex = Math.max(lbIndex - 1, 0); snapToSlide(); }
      else if(e.key === 'ArrowRight'){ lbIndex = Math.min(lbIndex + 1, lbImages.length - 1); snapToSlide(); }
    });

    /* Swipe handling */
    var track = document.getElementById('jfc-lb-track');
    var startX = 0, startY = 0, moveX = 0, isSwiping = false, startTime = 0;
    var lastTap = 0;

    track.addEventListener('touchstart', function(e){
      if(lbZoom > 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      moveX = 0;
      isSwiping = false;
      startTime = Date.now();

      /* Double-tap detection */
      var now = Date.now();
      if(now - lastTap < 300){
        e.preventDefault();
        toggleZoom(e.touches[0].clientX, e.touches[0].clientY);
        lastTap = 0;
        return;
      }
      lastTap = now;
    }, {passive:false});

    track.addEventListener('touchmove', function(e){
      if(lbZoom > 1){
        handlePan(e);
        return;
      }
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if(!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) isSwiping = true;
      if(isSwiping){
        e.preventDefault();
        moveX = dx;
        track.style.transform = 'translateX(' + (-(lbIndex * 100) + (moveX / track.offsetWidth * 100)) + '%)';
      }
    }, {passive:false});

    track.addEventListener('touchend', function(e){
      if(lbZoom > 1) return;
      if(!isSwiping){
        /* Check for downward swipe to close */
        var dy = e.changedTouches[0].clientY - startY;
        if(dy > 80 && Math.abs(moveX) < 30) closeLightbox();
        return;
      }
      var threshold = track.offsetWidth * 0.2;
      var velocity = Math.abs(moveX) / (Date.now() - startTime);
      if(moveX < -threshold || (moveX < -30 && velocity > 0.3)){
        lbIndex = Math.min(lbIndex + 1, lbImages.length - 1);
      } else if(moveX > threshold || (moveX > 30 && velocity > 0.3)){
        lbIndex = Math.max(lbIndex - 1, 0);
      }
      snapToSlide();
    });

    /* Pinch zoom */
    var pinchDist = 0;
    track.addEventListener('touchstart', function(e){
      if(e.touches.length === 2){
        pinchDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      }
    });
    track.addEventListener('touchmove', function(e){
      if(e.touches.length === 2){
        e.preventDefault();
        var dist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        var newScale = lbZoom * (dist / pinchDist);
        lbZoom = Math.min(4, Math.max(1, newScale));
        pinchDist = dist;
        applyZoom();
      }
    }, {passive:false});
    track.addEventListener('touchend', function(e){
      if(e.touches.length < 2 && lbZoom < 1.1){
        lbZoom = 1;
        lbPanX = 0;
        lbPanY = 0;
        applyZoom();
      }
    });

    return lb;
  }

  function toggleZoom(cx, cy){
    if(lbZoom > 1){
      lbZoom = 1; lbPanX = 0; lbPanY = 0;
    } else {
      lbZoom = 2.5;
      /* Zoom toward tap point */
      var slide = document.querySelectorAll('.jfc-lb-slide')[lbIndex];
      if(slide){
        var rect = slide.getBoundingClientRect();
        lbPanX = (rect.width/2 - (cx - rect.left)) * 0.5;
        lbPanY = (rect.height/2 - (cy - rect.top)) * 0.5;
      }
    }
    applyZoom();
  }

  var panStartX, panStartY, panBaseX, panBaseY;
  function handlePan(e){
    if(e.touches.length !== 1 || lbZoom <= 1) return;
    e.preventDefault();
    var dx = e.touches[0].clientX - (panStartX || e.touches[0].clientX);
    var dy = e.touches[0].clientY - (panStartY || e.touches[0].clientY);
    if(!panStartX){ panStartX = e.touches[0].clientX; panStartY = e.touches[0].clientY; panBaseX = lbPanX; panBaseY = lbPanY; }
    lbPanX = panBaseX + dx;
    lbPanY = panBaseY + dy;
    applyZoom();
  }
  document.addEventListener('touchend', function(){ panStartX = null; panStartY = null; });

  function applyZoom(){
    var img = document.querySelectorAll('.jfc-lb-slide img')[lbIndex];
    if(img) img.style.transform = 'scale('+lbZoom+') translate('+lbPanX/lbZoom+'px,'+lbPanY/lbZoom+'px)';
  }

  function snapToSlide(){
    var track = document.getElementById('jfc-lb-track');
    track.style.transition = 'transform .3s cubic-bezier(.4,0,.2,1)';
    track.style.transform = 'translateX(-' + (lbIndex * 100) + '%)';
    setTimeout(function(){ track.style.transition = ''; }, 300);
    updateLbUI();
    lbZoom = 1; lbPanX = 0; lbPanY = 0;
    document.querySelectorAll('.jfc-lb-slide img').forEach(function(i){ i.style.transform = ''; });
  }

  function updateLbUI(){
    var c = document.getElementById('jfc-lb-counter');
    if(c) c.textContent = (lbIndex + 1) + ' / ' + lbImages.length;
    document.querySelectorAll('.jfc-lb-dot').forEach(function(d, i){
      d.classList.toggle('act', i === lbIndex);
    });
    var prev = document.getElementById('jfc-lb-prev'), next = document.getElementById('jfc-lb-next');
    var single = lbImages.length <= 1;
    if(prev){ prev.toggleAttribute('disabled', lbIndex === 0); prev.style.display = single ? 'none' : ''; }
    if(next){ next.toggleAttribute('disabled', lbIndex === lbImages.length - 1); next.style.display = single ? 'none' : ''; }
    var dotsEl = document.getElementById('jfc-lb-dots');
    if(dotsEl) dotsEl.style.display = single ? 'none' : '';
  }

  function openLightbox(index){
    lbIndex = index || 0;
    lbZoom = 1; lbPanX = 0; lbPanY = 0;
    var lb = document.getElementById('jfc-lightbox') || buildLightbox();
    var track = document.getElementById('jfc-lb-track');
    var dots = document.getElementById('jfc-lb-dots');

    track.innerHTML = '';
    dots.innerHTML = '';
    lbImages.forEach(function(src, i){
      var slide = document.createElement('div');
      slide.className = 'jfc-lb-slide';
      var img = document.createElement('img');
      img.src = src.replace(/&width=\d+/, '&width=1200').replace(/\?width=\d+/, '?width=1200');
      img.alt = 'Product image ' + (i + 1);
      img.draggable = false;
      slide.appendChild(img);
      track.appendChild(slide);

      var dot = document.createElement('div');
      dot.className = 'jfc-lb-dot' + (i === lbIndex ? ' act' : '');
      dot.addEventListener('click', function(){ lbIndex = i; snapToSlide(); });
      dots.appendChild(dot);
    });

    track.style.transform = 'translateX(-' + (lbIndex * 100) + '%)';
    updateLbUI();
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox(){
    var lb = document.getElementById('jfc-lightbox');
    if(lb) lb.classList.remove('open');
    document.body.style.overflow = '';
    lbZoom = 1; lbPanX = 0; lbPanY = 0;
  }

  function initLightbox(){
    var mediaItems = document.querySelectorAll('.product__media-item img, .product__media img.motion-reduce');
    if(mediaItems.length === 0) return;

    lbImages = [];
    mediaItems.forEach(function(img){
      var src = img.src || img.dataset.src || '';
      if(src && lbImages.indexOf(src) === -1) lbImages.push(src);
    });

    if(lbImages.length === 0) return;

    /* Tap to open on mobile */
    mediaItems.forEach(function(img, i){
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        /* Find which image index this corresponds to */
        var src = img.src || img.dataset.src || '';
        var idx = lbImages.indexOf(src);
        openLightbox(idx >= 0 ? idx : 0);
      });
    });
  }


  /* ════════════════════════════════════════════════
     4. BACK TO TOP BUTTON
     ════════════════════════════════════════════════ */
  function initBackToTop(){
    var btn = document.createElement('button');
    btn.id = 'jfc-btt';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function(){
      window.scrollTo({top:0, behavior:'smooth'});
    });

    var stickyBar = document.getElementById('jfc-sticky');
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var show = window.scrollY > 600;
        btn.classList.toggle('vis', show);
        if(stickyBar) btn.classList.toggle('shifted', stickyBar.classList.contains('vis'));
        ticking = false;
      });
    }, {passive:true});
  }


  /* ════════════════════════════════════════════════
     5. SWIPE HINT ON GALLERY
     ════════════════════════════════════════════════ */
  function initSwipeHint(){
    if(window.innerWidth > 749) return;
    var gallery = document.querySelector('.product__media-wrapper, .product--media');
    var slider = gallery && gallery.querySelector('.slider, .grid--peek');
    if(!gallery || !slider) return;

    var mediaCount = slider.querySelectorAll('.product__media-item, .slider__slide').length;
    if(mediaCount < 2) return;

    var hint = document.createElement('div');
    hint.className = 'jfc-swipe-hint';
    hint.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>Swipe';
    gallery.style.position = 'relative';
    gallery.appendChild(hint);

    setTimeout(function(){ hint.classList.add('vis'); }, 1500);
    setTimeout(function(){ hint.classList.remove('vis'); }, 6000);

    /* Hide on first scroll */
    slider.addEventListener('scroll', function(){
      hint.classList.remove('vis');
    }, {passive:true, once:true});
  }


  /* ════════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════════ */
  function init(){
    initImageCounter();
    initLightbox();
    initBackToTop();
    initSwipeHint();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
